import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import { ORGANIZATION_CHANGES } from '../../constants/tableTypes'

const initialState = {
  data: [],
}

const organizationHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case `REPLACE_TABLE_USER_INFO_${ORGANIZATION_CHANGES}`:
      return reducers.dataTable.replaceTableUsersInfoReducer(
        ORGANIZATION_CHANGES,
        state,
        action
      )
    default:
      return reducers.auditTable.auditTableReducer(ORGANIZATION_CHANGES)(
        state,
        action
      )
  }
}

export default combineReducers({
  data: organizationHistoryReducer,
  tableInfo: reducers.auditTableColumnDefinitions(ORGANIZATION_CHANGES),
  users: (state, action) =>
    reducers.dataTable.mappedUsersReducer(ORGANIZATION_CHANGES, state, action),
})
